<template>
  <div>
    <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      :row-edit="accessForm"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol sm="4" v-if="!isEdit">
            <div class="form-group">
              <label for="user">User</label>
              <model-select
                class="form-control"
                id="user"
                :options="userList"
                v-model="$v.accessForm.admin_code.$model"
                :isError="$v.accessForm.admin_code.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.accessForm.admin_code.$invalid"
                class="invalid-feedback-custom"
              >
                Name should be filled.
              </div>
            </div>
          </CCol>
          <CCol :sm="(isEdit) ? 6 : 4">
            <div class="form-group">

              <label for="menu">Menu</label>
              <multi-select
                :options="menuList"
                :selected-options="menuItem"
                @select="onSelect"
                v-model="$v.accessForm.menu.$model"
                :isError="$v.accessForm.menu.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></multi-select>
              <div
                v-if="
                  isEdit === false &&
                  (accessForm.menu === null || accessForm.menu.length === 0)
                "
                class="invalid-feedback-custom"
              >
                Menu should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.accessForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { MultiSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import _ from "lodash";
export default {
  name: "Menu-Access",
  components: { GlobalTable, MultiSelect },
  data() {
    return {
      title: "Menu Access",
      menuList: [],
      userList: [],
      fields: [
        { key: "admin_name", label: "Name", sorter: true },
        { key: "menu_label", label: "Menu", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      menuItem: [],
      accessForm: tableInterfaces.administrator_access_menu,
      isLoading: false,
      addButton: false,
      isEdit: false,
    };
  },
  validations() {
    if (this.isEdit) {
      return {
        accessForm: {
          admin_code: {  },
          menu: { required },
        },
      };
    } else {
      return {
        accessForm: {
          admin_code: { required },
          menu: { required },
        },
      };
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getMenuAccess();
      this.getMenuList();
      this.getUserList();
    },
    onSelect(menuItem, lastSelectItem) {
      this.menuItem = menuItem;
      this.accessForm.menu = menuItem;
    },
    getMenuAccess: function () {
      this.isLoading = true;
      this.axios
        .get("console/menu_access/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            //console.log(response.data.data)
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getMenuList: function () {
      this.axios.get("console/menu_access/menu").then((response) => {
        this.menuList = response.data.menu;
      });
    },
    getUserList: function () {
      this.axios.get("console/menu_access/user").then((response) => {
        this.userList = response.data.users;
      });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.menuItem = item.menu_value;
      this.accessForm.menu = item.menu_value;
      this.accessForm.admin_code = item.admin_code;
      this.accessForm.id = item.id;
    },
    resetForm: function () {
      for (var i in tableInterfaces.administrator_access_menu) {
        tableInterfaces.administrator_access_menu[i] = null;
      }
      this.accessForm = tableInterfaces.administrator_access_menu;
      this.menuItem = []; // reset
      this.isEdit = false;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/menu_access/add", this.accessForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/menu_access/update", this.accessForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
